import * as Yup from 'yup';

export const customerValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Numele este obligatoriu')
    .min(3, 'Numele trebuie să aibă cel puțin 3 caractere')
    .max(100, 'Numele nu poate depăși 100 de caractere'),
  
  email: Yup.string()
    .required('Email-ul este obligatoriu')
    .email('Adresa de email nu este validă'),
  
  phone: Yup.string()
    .required('Numărul de telefon este obligatoriu')
    .matches(
      /^07[0-8]\d{7}$/,
      'Numărul de telefon trebuie să fie un număr valid de mobil românesc (07XX XXX XXX)'
    )
});

export const addressValidationSchema = Yup.object().shape({
  judet: Yup.string()
    .required('Județul este obligatoriu'),
  
  localitate: Yup.string()
    .required('Localitatea este obligatorie'),
  
  strada: Yup.string()
    .required('Strada este obligatorie')
    .min(3, 'Strada trebuie să aibă cel puțin 3 caractere'),
  
  numar: Yup.string()
    .required('Numărul este obligatoriu'),
  
  bloc: Yup.string()
    .optional(),
  
  scara: Yup.string()
    .optional(),
  
  apartament: Yup.string()
    .optional()
});
